import { useTranslation } from 'react-i18next';

import { Button } from '~/components';

import { useRegistrationContext } from '../Registration.context';

type Props = Omit<Parameters<typeof Button>[0], 'emphasis' | 'onClick'>;

export const RegistrationAddReferralCodeButton = ({ ...delegated }: Props) => {
  const { referralCodeInformation, setShowReferralCodeForm, showReferralCodeForm } = useRegistrationContext();

  const { t } = useTranslation(['auth']);

  if (referralCodeInformation !== null || showReferralCodeForm) return null;

  return (
    <Button {...delegated} emphasis="secondary" onClick={() => setShowReferralCodeForm(true)}>
      {t('auth:registrationPage.common.referralCode.addButton')}
    </Button>
  );
};
